// extracted by mini-css-extract-plugin
export default {"infoHovered":"Info_infoHovered__Bp8Y6","info":"Info_info__75ukq","infoHoverer":"Info_infoHoverer__sbUDJ"};